// extracted by mini-css-extract-plugin
export var card = "_6z-0";
export var failedIcon = "_6z-4";
export var failedIconBadge = "_6z-3";
export var icon = "_6z-1";
export var successIcon = "_6z-2";